import { render } from "./ObjectPath.vue?vue&type=template&id=557c2ae1"
import script from "./ObjectPath.vue?vue&type=script&lang=js"
export * from "./ObjectPath.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akhenry/Code/openmct-clean/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__